import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import firebase from '../../store/api/fbConfig';

import { Box, Button, TextField, Alert, Stack } from '@mui/material';

import { makeStyles } from '../../compat/muiStyles';
import mainStyle from '../../assets/mainStyle';

const useStyles = makeStyles(() => ({
  ...mainStyle,
  root: {
    padding: '30px',
    width: '100%',
  },
  providerButton: {
    marginBottom: '10px',
  },
}));

const providerMap = {
  Google: () => new firebase.auth.GoogleAuthProvider(),
  Facebook: () => new firebase.auth.FacebookAuthProvider(),
  Twitter: () => new firebase.auth.TwitterAuthProvider(),
  GitHub: () => new firebase.auth.GithubAuthProvider(),
};

const Login = () => {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const finishSignIn = () => {
    window.location.href = '/';
  };

  const signInWithProvider = async providerName => {
    setError('');
    setBusy(true);
    try {
      await firebase.auth().signInWithPopup(providerMap[providerName]());
      finishSignIn();
    } catch (err) {
      setError(err.message || 'Sign in failed.');
    } finally {
      setBusy(false);
    }
  };

  const signInWithEmail = async event => {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      await firebase.auth().signInWithEmailAndPassword(email, password);
      finishSignIn();
    } catch (err) {
      setError(err.message || 'Email sign in failed.');
    } finally {
      setBusy(false);
    }
  };

  const createEmailAccount = async () => {
    setError('');
    setBusy(true);
    try {
      await firebase.auth().createUserWithEmailAndPassword(email, password);
      finishSignIn();
    } catch (err) {
      setError(err.message || 'Account creation failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className={classes.root}>
      <Box className={classes.Main}>
        <h1>Log in</h1>

        {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}

        <Stack spacing={1} sx={{ maxWidth: 420 }}>
          {Object.keys(providerMap).map(provider => (
            <Button
              key={provider}
              className={classes.providerButton}
              variant="outlined"
              disabled={busy}
              onClick={() => signInWithProvider(provider)}
            >
              Continue with {provider}
            </Button>
          ))}

          <Box component="form" onSubmit={signInWithEmail} sx={{ pt: 2 }}>
            <TextField
              fullWidth
              margin="normal"
              label="Email"
              type="email"
              value={email}
              onChange={event => setEmail(event.target.value)}
              autoComplete="email"
            />
            <TextField
              fullWidth
              margin="normal"
              label="Password"
              type="password"
              value={password}
              onChange={event => setPassword(event.target.value)}
              autoComplete="current-password"
            />
            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
              <Button type="submit" variant="contained" disabled={busy || !email || !password}>
                Log in
              </Button>
              <Button type="button" variant="outlined" disabled={busy || !email || !password} onClick={createEmailAccount}>
                Create account
              </Button>
            </Stack>
          </Box>
        </Stack>

        <Box className={classes.center} sx={{ mt: 2 }}>
          By logging in, you accept <NavLink to="/terms">Terms and Conditions</NavLink> and <NavLink to="/privacy">Privacy Policy</NavLink>
        </Box>
      </Box>
    </main>
  );
};

export default Login;
